"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyAccount = void 0;
exports.EmptyAccount = {
    nucleusDataType: "account",
    accountId: "",
    //noSupportForNewTemplates: false,
    externalAppsEnabled: false,
    accountName: "",
    accountLogoUrl: "",
    backgroundImageUrl: "",
    deviceTemplate: -1,
    callButtonText: "",
    callButtonText2: "",
    emergencyButtonText: "",
    familyCallButtonText: "",
    biometricsButtonText: "",
    addFamilyButtonText: "",
    memoryBoxButtonText: "",
    format12Hrs: false,
    screenSaverDelayInSeconds: 0,
    callTimeoutDelayInSeconds: 0,
    showVideoStats: false,
    requestTimeoutMessageTextForPatient: "",
    settingsAccessPIN: "0000",
    localeTag: "",
    countryTag: "",
    backgroundLogoBoxHeight: 0,
    backgroundLogoBoxWidth: 0,
    weightUnit: "Lb",
    dimFrom: "",
    dimTo: "",
    enableCallButtonSchedule: false,
    enableEmergencyButtonSchedule: false,
    offHoursMessage: "",
    hexAPI: "",
    hexUrl: "",
    hexnodeGroupId: 0,
    showBatteryStatus: true,
    screenOffBatterySaver: false,
    customLinkButtonText: null,
    customLinkButtonImageUrl: null,
    customLinkButtonUrl: null,
    customSchedulingButtonText: null,
    customSchedulingButtonImageUrl: null,
    callButtonSchedule: [],
    nucleusDeviceUXVersion: "V1",
    homeButtonEnabled: true,
    enableTalkToADoctorNow: true,
    enableScheduleADoctor: true
};
